import { render, staticRenderFns } from "./registerRule.vue?vue&type=template&id=abfc9df8&scoped=true&"
import script from "./registerRule.vue?vue&type=script&lang=js&"
export * from "./registerRule.vue?vue&type=script&lang=js&"
import style0 from "./registerRule.vue?vue&type=style&index=0&id=abfc9df8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfc9df8",
  null
  
)

export default component.exports